var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "user-details-experience-score-panel" }, [
    _c(
      "div",
      { staticClass: "experience-score-kpi" },
      [
        _vm.hasNoKpiData
          ? _c("div", { staticClass: "no-data-message" }, [
              _vm._v("\n      No Data To Display\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.userExperienceScoreKpi
          ? _c(
              "v-progress-circular",
              {
                attrs: {
                  value: _vm.scoreCompletion,
                  color: "#4D52E5",
                  size: 144,
                  width: 10,
                },
              },
              [
                _c("div", { staticClass: "kpi" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.userExperienceScoreKpi.toLocaleString(undefined, {
                          maximumFractionDigits: 1,
                          minimumFractionDigits: 1,
                        })
                      ) +
                      "\n      "
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "highcharts-light experience-score-footer-graph" },
      [
        _vm.userExperienceScoreTrend.length > 1
          ? _c(
              "div",
              [
                _c("highcharts", {
                  ref: "chartComponent",
                  attrs: { options: _vm.chartOptions },
                }),
              ],
              1
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }